// extracted by mini-css-extract-plugin
export default {"root":"style_root__vZjNx","container":"style_container__LewcW","image":"style_image__Y7SHj","printButton":"style_printButton__e0MIu"};